import type { DashboardAlert } from '@yawi/types';
import { ChevronRight, ReceiptText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/** Id que le pone el backend a la alerta de comprobantes sin revisar. */
export const PENDING_PAYMENTS_ALERT_ID = 'alert-payments-to-verify';

interface PendingPaymentsCardProps {
  alerts: DashboardAlert[];
  loading?: boolean;
}

/**
 * Banner de comprobantes esperando revision.
 *
 * Se alimenta de la alerta que el backend ya calcula, en vez de pedir el dato otra vez:
 * asi el banner y la lista de alertas no pueden mostrar cifras distintas. Dashboard.tsx
 * filtra esta alerta de AlertList para que no aparezca duplicada.
 *
 * Mismo tratamiento visual que las reservas por confirmar porque es la misma clase de
 * tarea: algo que un admin tiene que resolver, no un problema del condominio.
 */
export function PendingPaymentsCard({ alerts, loading }: PendingPaymentsCardProps) {
  const navigate = useNavigate();

  const alert = alerts.find((a) => a.id === PENDING_PAYMENTS_ALERT_ID);
  if (loading || !alert) return null;

  return (
    <div className="flex items-center gap-3 bg-[#F4EDDD] border-[0.5px] border-[#E3D6BA] rounded-lg px-3 py-2">
      <div className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 bg-[#EF9F27] text-white">
        <ReceiptText size={16} />
      </div>
      {/* Solo el detalle: ya se lee como frase completa ("1 comprobante · $200 por
          confirmar") y anteponerle el titulo lo volvia redundante. */}
      <p className="flex-1 text-[13px] font-medium leading-tight" style={{ color: '#3A2400' }}>
        {alert.detail}
      </p>
      <button
        onClick={() => navigate(alert.ctaAction)}
        className="flex-shrink-0 text-[11px] font-medium text-white bg-[#EF9F27] hover:bg-[#854F0B] rounded-[20px] px-3 py-1 flex items-center gap-0.5 whitespace-nowrap"
      >
        {alert.ctaLabel} <ChevronRight size={14} />
      </button>
    </div>
  );
}
